import React, { useState, useEffect } from 'react';
import Post from '../../../../../utils/Post';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../../utils/Common';

const EditarBloque = (p) => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const opciones = p.opciones ?? { flores: [], variedades: [], colores: [] };
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [data, setdata] = useState(p.data ?? {
        "id": null,
        "por_plan": 0,
        "flor_id": 0,
        "variedad_id": 0,
        "color_id": 0,
        "relaciones_vivero": 0,
        "relaciones_campo": 0
    });

    let fields = [
        { name: 'flor_id', label: 'Flor', help: "", options: opciones.flores },
        { name: 'variedad_id', label: 'Variedad', help: "", options: opciones.variedades },
        { name: 'color_id', label: 'Color', help: "", options: opciones.colores },
    ]

    const actualizar = async () => {
        if (data.flor_id === 0 || data.variedad_id === 0 || data.color_id === 0) {
            activeDialog(setdialog, 'Debes seleccionar los campos', 'error', 'Error');
            return;
        }
        let dataSend = { flor: data.flor_id, variedad: data.variedad_id, color: data.color_id, id: data.id };
        let resp = await Post('catalogos/flores/bloques/update', dataSend, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        p.close(resp.data);

    }

    const eliminar = async () => {
        let resp = await Post('catalogos/flores/bloques/delete', { id: data.id }, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        p.close(resp.data);
    }

    const eliminarConfimacion = () => {
        setdialog({
            tipo: "error",
            show: true,
            title: "CONFIRME PARA CONTINUAR",
            body: "¿Realmente desea eliminar el bloque?",
            respYes: "Si, eliminar",
            respNot: "Cancelar",
            funct: (resp) => { if (resp) eliminar(); setdialog({ show: false }) },
            size: 'm'
        });
    }

    return (
        <div className='vw-100 vh-100 blur-xl bg-white4' style={{ position: "fixed", top: 0, left: 0, zIndex: 999 }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 text-end mt-4' style={{ position: "sticky", left: 0, top: 0, zIndex: 15 }}>
                    <button className='btn btn-danger shadow me-2 round-xl border border-2 border-dark scale-continue-05' onClick={() => p.close(false)}>Cerrar</button>
                </div>
                <div className='bw-300 mt-2 bg-white3 border shadow round-xxl text-center text-300 h4'>{data.id ? 'Editar Bloque' : "Agregar bloque"}</div>
                <div className='w-100 m-0 p-0'></div>
                <div className='bw-700 round-m shadow-multi bg-white p-3'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {
                            fields.map((field, i) =>
                                <div key={field.name} className='form-group bw-300 m-1 mt-3'>
                                    <label className='text-bold w-100 text-start ps-2'>{field.label}</label>
                                    <select
                                        className='form-select shadow border'
                                        value={data[field.name]}
                                        onChange={(event) => setdata({ ...data, [field.name]: event.target.value })}
                                        name={field.name}>
                                        <option value={0}>Selecciona una opción</option>
                                        {
                                            field.options.map((opt, i) => <option key={opt.id} value={opt.id}>{opt.nombre}</option>)
                                        }
                                    </select>
                                </div>
                            )
                        }
                        <div className='w-100 mt-3'></div>
                        {data.id && <div className='bw-200 m-0 p-0'>
                            <button className='btn btn-danger shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={eliminarConfimacion}
                            >Eliminar bloque</button>
                        </div>}
                        <div className='w-100'></div>
                        <div className='bw-400 mt-4 mb-3 ms-0 me-0'>
                            <button className='btn btn-warning shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={actualizar}
                            >{data.id ? 'Guardar cambios' : "Agregar"}</button>
                        </div>

                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default EditarBloque;